/**
 * Services Mega Menu Tab Hover Functionality
 *
 * NOTE: Intentionally not wrapped in DOMContentLoaded — this listener attaches
 * to `document` directly, so it works even when the script is deferred or
 * delayed by WP Rocket. Waiting for DOMContentLoaded on a deferred/delayed
 * footer script causes the callback to never fire on the live site.
 */

document.addEventListener('mouseover', (e) => {
    const tab = e.target.closest('.service-tab-item');
    if (!tab) return;

    const targetId = tab.getAttribute('data-target');
    if (!targetId) return;

    const megaMenu = tab.closest('.services-mega-menu');
    if (!megaMenu) return;

    const cardTargetId = targetId.replace('service-center-', 'service-card-').replace('ind-center-', 'ind-card-');

    // Update Tabs
    megaMenu.querySelectorAll('.service-tab-item').forEach(t => t.classList.remove('active'));
    tab.classList.add('active');

    // Update Content
    megaMenu.querySelectorAll('.service-content-pane').forEach(pane => {
        pane.classList.remove('active');
        if (pane.id === targetId) {
            pane.classList.add('active');
        }
    });

    // Update Cards
    megaMenu.querySelectorAll('.service-card-pane').forEach(card => {
        card.classList.remove('active');
        if (card.id === cardTargetId) {
            card.classList.add('active');
        }
    });
});
